
    const appID = import.meta.env.VITE_ENV === 'production' ? 917726 : 917728;

    window.appID = appID; // Mount to global
    // Dispatch a custom event to signal appID is set
    window.dispatchEvent(new Event('appIDReady'));
  